import React, { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory, useParams } from 'react-router-dom';
import Table from 'src/Components/GenericTable';
import { AdminLayout } from 'src/Layouts';
import { useWindowWidth } from 'src/useWindowWidth';
import { M, getData, PROVIDERS, PROVIDERS_API, NAME, PHONE, TYPE_OF_SERVICE, stableSort, getComparator, ADD_PROVIDER, ROUTES, PROVIDER_TEXT, } from 'src/Utils';
import { Container, TableContainer, Title, Image, } from '../styles';
import { DeleteModal, ProviderCard } from 'src/Components/Common';
import { Add } from 'src/assets/Images';
import { deleteProvider } from './duck';
var headCells = [
    { id: 'first', numeric: false, disablePadding: false, label: NAME },
    {
        id: 'second',
        numeric: false,
        disablePadding: false,
        label: TYPE_OF_SERVICE,
    },
    { id: 'third', numeric: false, disablePadding: false, label: PHONE },
    { id: 'fourth', numeric: false, disablePadding: false, label: '' },
    { id: 'fifth', numeric: false, disablePadding: false, label: '' },
];
var WIDTHS = ['30%', '30%', '30%', '2%', '2%', '6%'];
var ProvidersPage = function () {
    var id = useParams().id;
    var history = useHistory();
    var windowWidth = useWindowWidth();
    var isSmallScreen = M >= windowWidth;
    var _a = useState(false), isDeleteModalOpen = _a[0], setIsDeleteModalOpen = _a[1];
    var _b = useState(), selectedProvider = _b[0], setSelectedProvider = _b[1];
    var _c = useState('first'), orderBy = _c[0], setOrderBy = _c[1];
    var _d = useState(), rows = _d[0], setRows = _d[1];
    var _e = useState(''), searchedItem = _e[0], setSearchedItem = _e[1];
    var isLoading = useQuery([PROVIDERS_API, isDeleteModalOpen, searchedItem], function () {
        return getData("/providers?name=" + searchedItem);
    }, {
        onSuccess: function (_a) {
            var providers = _a.providers;
            setRows(providers === null || providers === void 0 ? void 0 : providers.map(function (_a) {
                var name = _a.name, type_of_service = _a.type_of_service, phone = _a.phone, id = _a.id;
                return {
                    first: name,
                    second: type_of_service,
                    third: phone,
                    fourth: '',
                    fifth: '',
                    id: id,
                };
            }));
        },
        retry: false,
    }).isLoading;
    var mutateDeleteProvider = useMutation(deleteProvider, {
        onSuccess: function () { return setIsDeleteModalOpen(function (prev) { return !prev; }); },
    })[0];
    var onDelete = function (id) {
        id && mutateDeleteProvider({ id: id });
    };
    return (React.createElement(AdminLayout, null,
        React.createElement(Container, null,
            React.createElement(Title, null, PROVIDERS),
            isSmallScreen && (React.createElement(Image, { src: Add, onClick: function () { return history.push(ROUTES.new_provider); } })),
            React.createElement(TableContainer, null, rows &&
                (isSmallScreen ? (stableSort(rows, getComparator('asc', orderBy)).map(function (_a, index) {
                    var first = _a.first, second = _a.second, third = _a.third;
                    return (React.createElement(ProviderCard, { key: first + index, first: first, second: second, third: third, handleDelete: onDelete, historyText: ROUTES.modify_provider }));
                })) : (React.createElement(React.Fragment, null,
                    React.createElement(Table, { rows: rows, headCells: headCells, handleButtonClick: function () { return history.push(ROUTES.new_provider); }, modalButton: ADD_PROVIDER, widths: WIDTHS, topIndex: 5, className: "left", historyText: ROUTES.modify_provider, hasDots: true, shouldShowProviders: true, setProviderData: setSelectedProvider, handleDelete: function () { return setIsDeleteModalOpen(function (prev) { return !prev; }); }, setSearchedItem: setSearchedItem, searchedItem: searchedItem }))))),
            React.createElement(DeleteModal, { isOpen: isDeleteModalOpen, setIsOpen: setIsDeleteModalOpen, onDelete: function () { return onDelete(selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.id); }, itemLabel: PROVIDER_TEXT, toDelete: "" + (selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.first) }))));
};
export default ProvidersPage;
